import { ViewService } from "../service";
import { viewStoreApi } from "../store";

export function getViews(currentEngineId) {
  ViewService.getViews(currentEngineId).then((response) => {
    viewStoreApi.getState().setViews(response.views);
  });
}
